import {useEffect, useState} from 'react';
import {useSubtitle} from '../../../../../../common/helpers/react/hooks/useSubtitle';
import {tAsString} from '../../../../../../common/helpers/react/text/tAsString';
import {useControllers} from '../../../../../../common/helpers/react/hooks/useControllers';
import LockGroupsTable from './LockGroupsTable';
import LockGroupsToolbar from './LockGroupsToolbar';

export default function LockGroupsPresenter() {
    useSubtitle(tAsString('MANAGE_GROUPS'));

    const [checkedRows, setCheckedRows] = useState<string[]>([]);
    const groups = useControllers().groups;

    useEffect(() => {
        groups.refreshAllGroups().andWeAreDone();
    }, []);

    return (
        <>
            <h1>{tAsString('MANAGE_GROUPS')}</h1>
            <LockGroupsToolbar
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
            />
            <LockGroupsTable
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
            />
        </>
    );
}
